import { forwardRef, HtmlHTMLAttributes, memo } from "react";
import classNames from "classnames";

import styles from "./styles.module.scss";

export type DropdownListHeaderProps = HtmlHTMLAttributes<HTMLDivElement>

export const DropdownListHeader = memo(forwardRef<HTMLDivElement, DropdownListHeaderProps>((
  {
    children,
    className,
    ...props
  },
  ref,
) => {
  return (
    <div
      ref={ref}
      className={classNames(className, styles.root)}
      {...props}
    >
      {children}
    </div>
  );
}));